<template>
  <!--  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="250px">
      <div class="common-form">企业微信设置</div>
<!--      <el-form-item label="是否开启" prop="customer">-->
<!--        <el-checkbox v-model="form.is_open">是否开启企业微信通知</el-checkbox>-->
<!--      </el-form-item>-->
      <el-form-item label="企业微信corp_id">
        <el-input v-model="form.corp_id" class="max-w460"></el-input>
      </el-form-item>

      <!--应用配置-->
      <div class="box-card" v-for="(item,index) in form.appList" :key="index">
        <el-descriptions class="margin-top" :title="item.name +'配置列表'" :column="1" size="medium" border>
          <template slot="extra">
            <el-button type="warning" size="small" @click="toDelete(index)">删除</el-button>
            <el-button type="primary" size="small" v-if="!item.is_default" @click="setDefault(index)">设为默认</el-button>
            <el-button type="info" size="small" v-if="item.is_default" @click="setDefault(index)" :disabled="true">当前默认</el-button>
          </template>

<!--          <el-descriptions-item>-->
<!--            <template slot="label">-->
<!--              应用名称-->
<!--            </template>-->
<!--            <span class="max-w460">{{item.name}}</span>-->
<!--          </el-descriptions-item>-->
          <el-descriptions-item>
            <template slot="label">
              agent_id
            </template>
            <span class="max-w460">{{item.agent_id}}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              secret
            </template>
            <span class="max-w460">{{item.secret || '未设置'}}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              token
            </template>
            <span class="max-w460">{{item.token || '未设置'}}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              aesKey
            </template>
            <span class="max-w460">{{item.aesKey || '未设置'}}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div class="box-card" v-if="openAdd">
        <el-descriptions class="margin-top" :title="'新应用配置列表'" :column="1" size="medium" border>
          <el-descriptions-item>
            <template slot="label">
              应用名称
            </template>
            <el-input v-model="tempObj.name" class="max-w460"></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              agent_id
            </template>
            <el-input v-model="tempObj.agent_id" class="max-w460"></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              secret
            </template>
            <el-input v-model="tempObj.secret" class="max-w460"></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              token
            </template>
            <el-input v-model="tempObj.token" class="max-w460"></el-input>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              aesKey
            </template>
            <el-input v-model="tempObj.aesKey" class="max-w460"></el-input>
          </el-descriptions-item>
        </el-descriptions>
        <el-button type="warning" style="margin:10px" @click="addItem">确认添加此配置表单</el-button>
      </div>

      <div class="" style=" width: 100%;margin: 40px 600px">
        <el-button type="primary" size="small" @click="add">+ 添加新的应用配置</el-button>
      </div>
      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import AppSetting from "@/api/appsetting";

export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          is_open:'',
          corp_id: '',
          appList: [],
        },
        tempObj:{
          name: '',
          agent_id: '',
          secret: '',
          token: '',
          aesKey: '',
          is_default:false
        },
        isOpenAdd: false,
        openAdd: false,
        /*是否打开图片选择*/
        isupload:false,
      };
    },
    created() {
      this.getData()
    },
    methods: {
      getData() {
        let self = this;
        AppSetting.getWorkWxSetting({}, true)
          .then(data => {
            if(data.data.data != null) {
              self.form = data.data.data;
              if (!self.form.appList) {
                self.form.appList = []
              }
            }
          })
          .catch(error => {});
      },
      //提交表单
      onSubmit() {
        let self = this;
        if(!this.form.corp_id){
          self.$message({
            message: '请完善配置信息,再提交哦!',
            type: 'error'
          });
          return false
        }
        let params = this.form;
        AppSetting.setWorkWxSetting(params, true)
          .then(data => {
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });
          })
          .catch(error => {});
      },
      //添加应用配置
      add(){
        this.tempObj = {
          name: '',
          agent_id: '',
          secret: '',
          token: '',
          aesKey: '',
          is_default: false
        }
        this.openAdd = true
      },
      addItem() {
        if(!this.tempObj.name || !this.tempObj.agent_id){
          this.$message({
            message: '请完善应用名称和agent_id',
            type: 'error'
          });
          return false
        }
        if (!this.form.appList) {
          this.form.appList = []
        }
        this.form.appList.push(this.tempObj)
        this.openAdd = false
      },
      //删除应用配置
      toDelete(index){
        let self = this
        if(self.form.appList[index].is_default){
          self.$message({
            message: '默认的不可删除',
            type: 'error'
          });
        }else {
          this.form.appList.splice(index,1)
        }
      },
      //设为默认
      setDefault(e){
        let self = this
        self.form.appList.map((item,index) =>{
          if(index == e){
            item.is_default = true
          }else{
            item.is_default = false
          }
        })
      },
    }

  };
</script>

<style lang="scss" scoped>
  .box-card{
    margin: 15px auto;
    width: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appwxwork/part/pay.vue